import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const ProgressStepDSO = {
    name: 'ProgressStepDSO',
    state: {
        steps: {
            0: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 0, label: '' },
            1: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 20, label: 'Location' },
            2: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 20, label: 'Rate Schdule' },
            3: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 20, label: 'Display' },
            4: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 20, label: 'Connect Stripe' },
            5: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 10, label: 'Avatar' },
            6: { isCompleted: false, isActive: false, isDisable: false, isSkipped: false, points: 10, label: 'Add User' },
        },
        step: 0,
        completed: false,
        newData: {},
    },
    reducers: {
        progressRequested(state) {
            return { ...state, step: 0, completed: false };
        },
        progressCompleted(state) {
            return { ...state, completed: true };
        },
        setData(state, payload) {
            return { ...state, newData: payload };
        },
        stepSkipped(state, payload) {
            const newSteps = { ...state.steps, [payload]: { ...state.steps[payload] } };
            newSteps[payload].isSkipped = true;
            newSteps[payload].isCompleted = true;
            newSteps[payload].isActive = false;
            newSteps[payload].isDisable = true;
            return { ...state, step: payload, steps: newSteps };
        },
        progressReveived(state, payload, check) {
            const newSteps = { ...state.steps, [payload]: { ...state.steps[payload] } };
            const newData = state.newData;
            if (check === 'update') {
                Object.keys(newSteps).forEach(key => {
                    newSteps[key].isActive = false;
                });
                newSteps[payload].isActive = true;
            } else if (check === 'delete') {
                newSteps[payload].isCompleted = false;
                newSteps[payload].isDisable = false;

                if (payload === 2) {
                    newSteps[payload + 1].isCompleted = false;
                    newSteps[payload + 1].isDisable = false;
                } else if (payload === 1) {
                    newSteps[payload + 2].isCompleted = false;
                    newSteps[payload + 2].isDisable = false;
                }
            } else if (check === 'get') {
                newSteps[payload].isCompleted = true;
                newSteps[payload].isDisable = true;
                newSteps[payload].isActive = false;
            } else if (check === 'skipped') {
                newSteps[payload].isCompleted = true;
                newSteps[payload].isDisable = true;
                newSteps[payload].isActive = false;
                newSteps[payload].isSkipped = true;
            } else if (check === 'skip' && newData.isUserSkipped) {
                newSteps[payload].isCompleted = true;
                newSteps[payload].isDisable = true;
                newSteps[payload].isActive = false;
                newSteps[payload].isSkipped = true;
            }

            const completedSteps = Object.keys(newSteps).filter(key => newSteps[key].isCompleted).length;
            const isCompleted = completedSteps === 6;

            return { ...state, step: payload, steps: newSteps, completed: isCompleted };
        },
        progressFailed(state, payload) {
            return { ...state, step: state.step, steps: state.steps, completed: false };
        },
        clearMessages(state) {
            return { ...state, step: 0, completed: false };
        },
    },
    effects: (dispatch) => ({
        async GetDSOProgressStep() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const orgId = userInfo?.org_id;
                const locationsUrl = `savvy/locations/lookup/${orgId}`;
                const displaysUrl = `savvy/displays/lookupDisplays/${orgId}`;
                const rateSchedulesUrl = `savvy/rate-schedule/lookup/${orgId}`;
                const url = `savvy/users/verifyConnect/${orgId}`;
                const usersUrl = `savvy/users/countUsers/${orgId}`;

                const response = await http.get(locationsUrl);
                if (response && response.data) {
                    const { data } = response.data;
                    if (data && data.length > 0) {
                        this.progressReveived(1, 'get');
                    } else {
                        this.progressFailed('No data available');
                    }
                }

                const rateSchedulesResponse = await http.get(rateSchedulesUrl);
                if (rateSchedulesResponse && rateSchedulesResponse.data) {
                    const { data } = rateSchedulesResponse.data;
                    if (data && data.length > 0) {
                        this.progressReveived(2, 'get');
                    } else {
                        this.progressFailed('No data available');
                    }
                }

                const displaysResponse = await http.get(displaysUrl);
                if (displaysResponse && displaysResponse.data) {
                    const { data } = displaysResponse.data;
                    if (data && data.length > 0) {
                        this.progressReveived(3, 'get');
                    } else {
                        this.progressFailed('No data available');
                    }
                }

                const usersData = await http.get(url);
                if (usersData && usersData.data) {
                    const { data } = usersData.data;
                    if (data && data.connect_account_id) {
                        this.progressReveived(4, 'get');
                    } else {
                        this.progressFailed('No data available');
                    }
                    if (data && data.avatar) {
                        this.progressReveived(5, 'get');
                    }
                }

                const usersResponse = await http.get(usersUrl);
                if (usersResponse && usersResponse.data) {
                    const { data } = usersResponse.data;
                    if (data && data.count > 1) {
                        this.progressReveived(6, 'get');
                    } else {
                        this.setData(usersData.data.data);
                        this.progressReveived(6, 'skip');
                    }
                } else {
                    this.progressFailed('No data available');
                }

            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async UpdateGetDSOProgressStep(newStep) {
            try {
                this.progressReveived(newStep, 'get');
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async UpdateDSOProgressStep(newStep) {
            try {
                this.progressReveived(newStep, 'update');
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async DeleteDSOProgressStep(newStep) {
            try {
                this.progressReveived(newStep, 'delete');
                const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
                storedUserInfo.isProfileCompleted = false;
                localStorage.setItem('userInfo', JSON.stringify(storedUserInfo));
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async SkippedDSOProgressStep(newStep) {
            try {
                this.progressReveived(newStep, 'skipped');
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async UpdateProfileSkipped(data) {
            try {
                const { id, isUserSkipped } = data;
                const url = `savvy/users/updateSkipped/${id}`;
                await http.put(url, { isUserSkipped });

            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async UpdateProfileProgress(score) {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                const id = userInfo?.id;
                const url = `savvy/users/updateScore/${id}`;

                const response = await http.put(url, { score });
                if (response && response.data) {
                    const { data } = response.data;
                    if (data) {
                        const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
                        storedUserInfo.isProfileCompleted = response.data.data.isProfileCompleted;
                        localStorage.setItem('userInfo', JSON.stringify(storedUserInfo));
                    } else {
                        this.progressFailed('No data available');
                    }
                }
            } catch (err) {
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async clearStateMessages() {
            this.clearMessages();
        },
    }),
};

export default ProgressStepDSO;